import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

function Courses() {
  const { interfaceLang, courseLang } = useParams();  // Récupérer les langues depuis l'URL
  const API_URL = process.env.REACT_APP_API_URL;
  const { t } = useTranslation();
  const [courses, setCourses] = useState([]);
  const [vocabulaireCategorie, setVocabulaireCategorie] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Liste des catégories pour affichage
  const CATEGORY_LABELS = {
    grammar: t('grammar'),
    conjugation: t('conjugation'),
    vocabulary: t('vocabulary'),
    communication: t('communication'),
  };

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    
    // Vérifier si l'utilisateur est connecté
    if (token) {
      setIsAuthenticated(true);
      
      // Récupérer la liste des cours pour la langue choisie
      axios.get(`${API_URL}/cours/api/courses/?lang=${courseLang}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => {
        setCourses(response.data);
      })
      .catch(error => {
        console.error("Erreur lors de la récupération des cours :", error);
      });

      // Récupérer la liste des catégories de vocabulaire disponible
      axios.get(`${API_URL}/cours/api/vocabulaire/?lang=${courseLang}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => {
        setVocabulaireCategorie(response.data);
      })
      .catch(error => {
        console.error("Erreur lors de la récupération des cours :", error);
      });
    }
  }, [courseLang]);
  
  // Grouper les cours par catégorie et les trier par ID
  const groupedCourses = courses.reduce((acc, course) => {
    const category = course.course_type; // Ex. 'grammar', 'conjugation'
    if (!acc[category]) acc[category] = [];
    acc[category].push(course);
    return acc;
  }, {});

  // Trier les cours au sein de chaque catégorie par ID croissant
  Object.keys(groupedCourses).forEach(category => {
    groupedCourses[category].sort((a, b) => a.id - b.id);
  });


  //Grouper les catégorie de vocabulaire par thème
  const groupedVocabulaire = vocabulaireCategorie.reduce((acc, vocab) => {
    const category_vocab = vocab.category_theme; // Ex. 'Nourriture', 'Travail'
    if (!acc[category_vocab]) acc[category_vocab] = [];
    acc[category_vocab].push(vocab);
    return acc;
  }, {});

  // Trier les cours au sein de chaque catégorie par ID croissant
  Object.keys(groupedVocabulaire).forEach(category_vocab => {
    groupedVocabulaire[category_vocab].sort((a, b) => a.id - b.id);
  });




  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center">
      <h1 className="text-4xl font-bold mb-6 text-blue-600">{t('availableCourses')}</h1>
      <div className="w-full max-w-6xl space-y-8">
        {Object.keys(groupedCourses).map(category => (
          <div key={category}>
            {/* Sous-titre pour chaque catégorie */}
            <h2 className="text-2xl font-bold text-gray-700 mb-4">
              {CATEGORY_LABELS[category] || t('other')}
            </h2>
            <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {groupedCourses[category].map(course => (
                <li key={course.id}>
                  <Link
                    to={`/${interfaceLang}/course/${courseLang}/${course.slug}`}
                    className="block bg-white p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-blue-50 transition"
                  >
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">{course.title}</h3>
                    <p className="text-gray-600 mb-4">{course.description}</p>
                    <div className="text-sm text-gray-500">
                      <p className="font-semibold">{t('difficulty')} : {course.difficulty}</p>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div>
        <p>Vocabulaire</p>
        <p>Global</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <li key="global">
              <Link
                to={`/${interfaceLang}/courses/${courseLang}/vocabulary/global`}
                className="block bg-white p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-blue-50 transition"
              >
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Global</h3>
                <p className="text-gray-600 mb-4">Global_description</p>
                <div className="text-sm text-gray-500">
                  <p className="font-semibold">{t('difficulty')} : 3</p>
                </div>
              </Link>
            </li>
        </ul>
        {Object.keys(groupedVocabulaire).map(category_vocab => (
          <div key={category_vocab}>
            {/* Sous-titre pour chaque catégorie */}
            <h2 className="text-2xl font-bold text-gray-700 mb-4">
              {category_vocab || t('other')}
            </h2>
            <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {groupedVocabulaire[category_vocab].map(vocabulaireCategorie => (
                <li key={vocabulaireCategorie.id}>
                  <Link
                    to={`/${interfaceLang}/courses/${courseLang}/vocabulary/${vocabulaireCategorie.name}`}
                    className="block bg-white p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-blue-50 transition"
                  >
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">{vocabulaireCategorie.name}</h3>
                    <p className="text-gray-600 mb-4">{vocabulaireCategorie.description}</p>
                    <div className="text-sm text-gray-500">
                      <p className="font-semibold">{t('difficulty')} : {vocabulaireCategorie.category_difficulty}</p>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Courses;
